module.exports = __webpack_public_path__ + "img/bg-1.6ed8c4a7.jpg";